namespace Gordic.Pod.Lists
{
    @Decorators.gcontent
    export class ElPodaniNezpracovanaAC extends GContentBase<PodListBaseAC>
    {
        model: Gordic.Wfl.Client.GElPodaniNezpracovanaFilterDto;
        MailboxInfoDto: Wfl.Interface.GMailboxInfoDto;
        IfOdeslatPotvrzeni: boolean = false;

        onContentReady() {
            let that = this;
            PodListBaseAC.InitList(this);
            this.topActions.push(this.CreateActionElPodani());
            this.topActions.push(this.CreateActionHromadneElPodani());
            this.topActions.push(this.CreateActionNacistMailovouSchranku());
            this.topActions.push(this.CreateActionNacistDatovouSchranku());
            this.topActions.push(this.CreateActionNacistDatovouSchrankuPsrSK());
            this.topActions.push(this.CreateActionNacistDorucenkyDZ());
            if (this.SessionInfo.IsVyvoj) this.topActions.push(this.CreateActionZamkniMailboxTest());
            this.specialActions.push(PodListBaseAC.CreateActionZobrazitZpravu(this, true));
            this.specialActions.push(PodListBaseAC.CreateActionUlozitZpravu(this, true));
            this.specialActions.push(this.CreateActionRozdelit());
            this.specialActions.push(Gordic.Wfl.ListAC.WflListBaseAC.CreateActionStornovat(this));
            this.specialActions.push(PodListBaseAC.CreateActionOdemknoutElPodani(this));
            this.specialActions.push(PodListBaseAC.CreateActionZobrazitPotvrzeniODoruceni(this));
            this.specialActions.push(this.CreateActionPrevzit());
            this.specialActions.push(PodListBaseAC.CreateActionOdeslatPotvrzeniODoruceni(this, true));
            
            Gordic.Wfl.ListAC.WflListBaseAC.CompleteMenu(this);

            // samotná definice gfilterpanelu
            this.filterForm = $("<div>")
                .appendTo(this.element)
                .on("gfilterpanelapply", function (event, obj) {         // eventa která je vyvolána při vyhledávání. obj.filter -> hledaný seznam podmínek
                    that.LoadData(obj.filter);
                }).gfilterpanel({
                    forms: this.CreateFilterForms(), // poleFormu ktere budou pouzity pro podminky
                    favorites: "all",                           // defaultní oblíbené
                    filterStorageService: new Gordic.Gin.FilterStorageService.Store({ tema: "pod_ptm_nezrep" }), 
                    favoriteLayoutDescriptor: Gordic.Gin.Globals.Enums.LayoutDescriptorType.list,
                    poVyhledaniZobrazit: "OblibenePodminky"
                });

            this.CreateGrid();
            this.filterForm.gfilterpanel("applyFilter", this.model, !this.NacistSeznamPriOtevreni)      
        }

        CreateFilterForms()
        {
            var filterForm = new Gordic.Forms.Form({ name: "FormDocsList", tabLabel: "jres:23900223", layoutDescriptor: "L2M2S1, L-3-8-1, M-12-11-1, S-12-11-1, breaks-700-1000" }) 
                .addRow({ label: "jres:23900003" }).addField("gselectbox", {
                    list: true,
                    name: "Vlastnictvi",

                    data: new Gordic.Data.View([
                        { val: Gordic.Wfl.Interface.FiltrDleVlastnictviEnum.Vsechny, text: 'jres:23900004' }, //RC 23900004 : vše
                        { val: Gordic.Wfl.Interface.FiltrDleVlastnictviEnum.Vlastni, text: 'jres:23900005' }, //RC 23900005 : vlastní
                        { val: Gordic.Wfl.Interface.FiltrDleVlastnictviEnum.Nerozdelene, text: 'jres:23900006' }, //RC 23900006 : nerozdělené
                    ], { key: "val" }),
                    itemTemplate: "{text}",
                    model: "model.Vlastnictvi=value.val",
                    initialValue: { val: this.model.Vlastnictvi },
                    itemWidth: "",
                });
            filterForm.addPrefab(ListPrefabs.SekceFilterDlePodepsani({ initialValue: this.model.Podepsani } as GRadioOptions<any>));

            filterForm.addPrefab(ListPrefabs.SekceFilterDleZpusobuDoruceni({
                email: { initialValue: this.model.TypPrijmu_EMail },
                ElNosic: { initialValue: this.model.TypPrijmu_DatovyNosic },
                    DS: { initialValue: this.model.TypPrijmu_DS },
                    WebPodatelna: { initialValue: this.model.TypPrijmu_WebPodatelna },
                    GEX: { initialValue: this.model.TypPrijmu_GEX },
                    ostatni: { initialValue: this.model.TypPrijmu_Ostatni }
                })
            );

            return [filterForm];
        }

        CreateGrid(): void {
            var that = this;
            var gf = Gordic.Wfl.ListAC.WflListBaseAC.GetGridFormat();
            gf.addIconColumn(Gordic.Gin.Globals.GridIconOptResulInfo());
            gf.addIconColumn(Gordic.Wfl.ListPrefabs.IconZpusobDoruceni(this.ImageDelegateZpusobDoruceni));
            gf.addIconColumn(Gordic.Wfl.ListPrefabs.IconStavElPodani(this.ImageDelegateStavPodani));
            gf.addIconColumn(ListPrefabs.IconStavRozlozeni(this.ImageDelegateStavRozlozeni));
            gf.addIconColumn(Gordic.Wfl.ListPrefabs.DelegateElPodpisIcon());
            gf.addTextColumn(ListPrefabs.ixbColumn());                
            gf.addDateTimeColumn(Gordic.Wfl.ListPrefabs.datPodaniColumn("jres:23900020")); //RC 23900020 : Datum dodání
            gf.addDateTimeColumn(ListPrefabs.datPrijColumn());      
            gf.addTextColumn(Gordic.Wfl.ListPrefabs.poznamkaColumn());    
            gf.addTextColumn(Gordic.Wfl.ListPrefabs.stavPodaniColumn());
            gf.addTextColumn(Gordic.Wfl.ListPrefabs.mailFromColumn());
            gf.addTextColumn(Gordic.Wfl.ListPrefabs.mailToColumn());
            gf.addTextColumn(ListPrefabs.IDZpravyColumn());
            if (this.PsrSKVisible) gf.addTextColumn(ListPrefabs.IDCorrelation());
            gf.addTextColumn(ListPrefabs.UIDLColumn());
            gf.addTextColumn(Gordic.Wfl.ListPrefabs.mailboxColumn());
            gf.addTextColumn(Gordic.Wfl.ListPrefabs.zpusobDoruceniColumn());
            gf.addDateTimeColumn(Gordic.Wfl.ListPrefabs.datZpracovaniColumn());
            gf.addTextColumn(ListPrefabs.nazevFunkceZpracovateleColumn());

            var OpenElPodani = new GAction({     //obsluzna akce, ktera se spousti dbl clickem nad radkem
                name: "gridRowSelectedAct",
                run: function (ev, ctx) {
                    var rowData = ctx.cellInfo.data; //data, ze kterych byl vytvoren radek
                    var l_po: string[] = [];
                    l_po.push(rowData.ixb);                
                    Gordic.Pod.Dialogs.EvidenceElPodaniDlg(that, { IxbArray: l_po, PouzePrehled: false }, Global.Enums.ModOtevreni.navigate)
                        .done(function (retVal: any) {
                            that.ReloadData();
                            if (retVal && retVal.zobrazitDetailPozavreniPruvodce && retVal.pidDokumentu) { 
                                var opt = {
                                    DetailDto:
                                    {
                                        ixp: retVal.pidDokumentu
                                    }
                                };
                                Gordic.Wfl.Dialogs.DetailDokumentuSpisu(that, opt);
                            }
                        }
                        );
                }
            })

            let m_iPocetDniZprac = (this as any).globalSettings.get("Global.Pod.AppSettings.PodElPodaniSettings.PocetDniKeZpracovani");
            let m_iPocetHodPredZprac = (this as any).globalSettings.get("Global.Pod.AppSettings.PodElPodaniSettings.PocetDniKeZpracovani");

            this.gridOptions = {};
            this.gridOptions.defaultAction = OpenElPodani;
            this.gridOptions.rowsClass = function (dataRow) {
                var l_ret = "  ";
                if (dataRow && dataRow.data) {
                    if (dataRow.data.stav_inb == 0) {
                        //&& dataRow.data.dat_pod == 55 || dataRow.data.stupen_ver == 65
                        l_ret = "bold";
                    }

                    if (dataRow.data.priz_dovl_rukou == 1) {
                        l_ret = "bold";
                    }
                    var l_textState = "g-state-text ";
                 
                        switch (dataRow.data.stav_inb) {
                            case 0:
                                if (m_iPocetDniZprac && m_iPocetDniZprac != undefined && m_iPocetDniZprac > 0)
                                {
                                    const DT = Gordic.Utils.DateTime;
                                    var l_akDate = new Date()
                                    var l_datDoruc = parseDate(dataRow.data.dat_pod);
                                    var l_rozdil = DT.diff(l_datDoruc, DT.addDays(l_akDate, - m_iPocetDniZprac), "days")

                                    if (l_rozdil > 0) {
                                        l_ret = l_textState + Gordic.Global.Enums.ColorStateClass.error;
                                        break;
                                    }
                                    else
                                    {
                                        if (m_iPocetHodPredZprac && m_iPocetHodPredZprac != undefined && m_iPocetHodPredZprac > 0)
                                        {
                                            if (l_datDoruc < DT.addHours(l_akDate, -m_iPocetHodPredZprac)) l_ret = l_textState + Gordic.Global.Enums.ColorStateClass.info;
                                        }
                                    }
                                }
                                break;

                            default:
                                var l_ret = "  ";
                                //l_ret = l_textState + Gordic.Global.Enums.ColorStateClass.inactive;
                                break;
                        
                    }
                }
                return l_ret;
            };
            this.gridOptions.rowsEnabled = function (dataRow) {
                var l_ret = true;
                switch (dataRow.data.stav_inb) {
                    case 0:
                        break;

                    default:
                        l_ret = false;
                        break;
                }
                return l_ret;
            };

            var grid = Gordic.Wfl.ListAC.WflListBaseAC.CreateGridBase(this, gf);
            this.mainGrid = grid;
            Gordic.Wfl.ListAC.WflListBaseAC.AfterCreateGrid(this);
        }

        LoadData(filtr?: Gordic.Wfl.Client.GElPodaniNezpracovanaFilterDto)
        {
            if (this.MailboxInfoDto.NacistMailSchrankuVisible && this.MailboxInfoDto.NacistSchrankuPriNacteniSeznamu)
            {
                this.NacistMailovouSchranku();
                this.MailboxInfoDto.NacistSchrankuPriNacteniSeznamu = false;
            }
            else this.LoadDataSeznam(filtr);
        }

        LoadDataSeznam(filtr?: Gordic.Wfl.Client.GElPodaniNezpracovanaFilterDto) {
            let that = this;
            Gin.Globals.ShowWaitLoadData(this);
            this.model = $.extend({}, this.model, filtr);
            this.call<Gordic.Wfl.Interface.GElPodaniDto[]>("LoadData", { "model": this.model })
                .done(function (data) {
                    var view = new Gordic.Data.View(data, { key: that.IDPrimaryKeyGridu });  //key je dulezity kvuli pripadnemu vyhledavani radku
                    that.mainGrid.ggrid("setData", view, true); //true = prekresleni gridu
                    //  } catch (e) { console.log("e", e) }

                    if (that.MailboxInfoDto.OdeslatPotvrzeni)
                    {
                        that.IfOdeslatPotvrzeni = false;
                        if (that.MailboxInfoDto.OdeslatPotvrzeni > 0)
                        {
                            // zjistim neodeslane
                            var idArray: string[] = [];
                            data.forEach(function (entry)
                            {
                                if (entry.priz_neodp == 10 && Gordic.Wfl.Globals.IsZpDorTypuEmailOrInternet(entry.zpusob_dor) && entry.priz_rozl == 0 && entry.stav_inb == 0)
                                {
                                    idArray.push(entry.ixb);
                                }
                            });
                            if (idArray.length > 0) that.OdeslatPotvrzeni(idArray);
                        }
                    }
                })
                .always(function () {
                    Gordic.Wfl.ListAC.WflListBaseAC.AfterLoadData(that);
                });
        }

        ReloadData()
        {
            this.LoadDataSeznam(this.model);
        }

        OdeslatPotvrzeni(_selected: string[]): JQuery.Promise<boolean> {
            let promis = $.Deferred<boolean>();
            this.PocetCelkem = _selected.length;
            if (this.PocetCelkem > 0)
            {
                this.Poradi = this.PocetCelkem;
                this.endOperation();

                //for (var i = 0; i < _selected.length; i++)
                //{
                //    promises.push(this.OdeslatKonkretniPotvrzeni(_selected[i]));
                //}

                //$.when.apply(null, promises).done(
                //    function ()
                //    {
                //        promis.resolve(true);
                //    });
                let promisKteryCekaNaVykonaniVsechDialogu = $.Deferred<boolean>();

                // zavolám postupné otevření dialogů
                this.OtevriPostupneDialogy(promisKteryCekaNaVykonaniVsechDialogu, _selected, 0)

                promisKteryCekaNaVykonaniVsechDialogu.done(function () {
                    promis.resolve(true);
                });
            }
            else {
                promis.resolve(false);
            }
            return promis.promise();
        }

        OtevriPostupneDialogy(deffered: JQuery.Deferred<boolean>,_selected: string[], index: number) {
            var that = this;
            // pokud na aktuálním indexu v poli je nějaká hodnota, tak otívrám dialog, jinak ukončuju v elsu Resolvem a je hotovo
            if (_selected.length > index) {
                // otevírám dialog na konkrétním indexu
                this.OdeslatKonkretniPotvrzeni(_selected[index])
                    .done(function (retDialog) {
                        // po zavření dialogu zvyšuju index o 1 a volám znova tu samou funkci pro postupne otevření dialogů
                        that.OtevriPostupneDialogy(deffered,_selected, index + 1);
                })
            } else {
                // Aktuálně je hotovo, všehcny indexy v pobli byly otevřeny 
                deffered.resolve(true);
            }
        }

        OdeslatKonkretniPotvrzeni(_ixb: string): JQuery.Promise<boolean> {
            let promis = $.Deferred<boolean>();
            Gordic.Pod.Dialogs.OdeslaniPotvrzeniODoruceniDlg(this, { IdEntity: _ixb }, Global.Enums.ModOtevreni.showModalWindow).done(function () {  promis.resolve(true) });           //promis.resolve(true);           
            return promis.promise();
        }

        CreateActionNacistDatovouSchranku(): GAction
        {
            let that = this;
            var l_tooltip = "jres:23900035";
            if (this.MailboxInfoDto.NacistDatovouSchrankuVisible) l_tooltip = this.MailboxInfoDto.LastDownLoadDatoveZpravy

            var action = new GAction({
                name: Gordic.Pod.Globals.ActionsName.nacistDatovouSchranku,
                icon: Gordic.Gin.Icons.EntityEnum.datovaZprava,
                caption: "jres:23900034", //RC 23900034 : Načíst DS
                tooltip: l_tooltip, //RC 23900035 : Načíst datovou schránku
                visible: this.MailboxInfoDto.NacistDatovouSchrankuVisible,
                groupName: Gordic.Gin.Globals.Enums.ActionsGroupName.FavoriteAlwaysEnabled,
                run: function (ev, ctx)
                {
                    that.NacistDatovouSchranku();
                }
            });
            return action;
        }

        CreateActionNacistDatovouSchrankuPsrSK(): GAction {
            let that = this;
            var action = new GAction({
                name: Gordic.Pod.Globals.ActionsName.nacistDatovouSchrankuPsrSK,
                icon: Gordic.Gin.Icons.ZpusobDoruceni.elSchrankaSK,
                caption: "jres:31950225", //RC 31950225 : Načti e-Desk
                tooltip: "jres:31950225", //RC 31950225 : Načti e-Desk
                visible: this.MailboxInfoDto.NacistDatovouSchrankuPsrSKVisible,
                groupName: Gordic.Gin.Globals.Enums.ActionsGroupName.FavoriteAlwaysEnabled,
                run: function (ev, ctx) {
                    Gin.Globals.ShowWaitLoadData(that);
                    that.call<Gordic.Gin.WebClient.GRetValDlg>("NacistDatovouSchrankuPsrSK")
                        .done(function (r) {
                            if (r.StavBool) {
                                if (r.Message) that.dialogs.alert(r.Message);
                                that.LoadData(that.model)
                            }
                            else {
                                that.endOperation();
                                if (r.ErrorMessage) that.dialogs.alert(r.ErrorMessage);
                            }
                        })
                        .always(function () {
                            that.endOperation();
                        });

                }
            });
            return action;
        }

        CreateActionZamkniMailboxTest(): GAction
        {
            let that = this;
            var action = new GAction({
                name: Gordic.Pod.Globals.ActionsName.nacistDatovouSchrankuPsrSK,
                icon: Gordic.Gin.Icons.ZpusobDoruceni.elSchrankaSK,
                caption: "ZAMKNI MAILBOX", //RC 31950225 : Načti e-Desk
                visible: this.MailboxInfoDto.NacistDatovouSchrankuPsrSKVisible,
                groupName: Gordic.Gin.Globals.Enums.ActionsGroupName.FavoriteAlwaysEnabled,
                run: function (ev, ctx)
                {
                    that.call("ZamkniMailbox", { Typ: Gin.Interface.TypMailboxu.email });
                }
            });
            return action;
        }

        SetToolTipByInfo()
        {
            if (this.MailboxInfoDto)
            {
                if (this.MailboxInfoDto.NacistMailSchrankuVisible)
                {
                    //Wfl.ListAC.WflListBaseAC.get.get
                }
            }
        }

        NacistMailovouSchranku()
        {
            let that = this;
            Gin.Globals.ShowWaitLoadData(this);
            this.KontrolaStavuSchranky(Gin.Interface.TypMailboxu.email)
                .done(function (r) {
                    if (r == true)
                    {
                        that.NacistMailovouSchrankuPoKontrole();
                    }
                })
                .always(function () {
                    that.endOperation();
                });
        }

        NacistMailovouSchrankuPoKontrole() {
            let that = this;
            Gin.Globals.ShowWaitLoadData(this);
            this.call<Gordic.Gin.WebClient.GRetValDlg>("NacistMailSchranku")
                .done(function (r)
                {
                      if (r.StavBool) {
                        that.IfOdeslatPotvrzeni = true;
                        that.LoadDataSeznam(that.model)
                          that.endOperation();
                          if (r.Message) Wfl.AC.WflBaseAC.ShowFlashSuccess(that, r.Message);
                    }
                    else {
                        that.endOperation();
                        if (r.Message) that.dialogs.alert(r.Message);
                        if (r.ErrorMessage) that.dialogs.alert(r.ErrorMessage);
                    }
                })
                .always(function () {
                    that.endOperation();
                });
        }

        NacistDatovouSchranku()
        {
            let that = this;
            Gin.Globals.ShowWaitLoadData(this);
            this.KontrolaStavuSchranky(Gin.Interface.TypMailboxu.datovaSchranka)
                .done(function (r) {
                    if (r == true) {
                        that.NacistDatovouSchrankuPoKontrole();
                    }
                })
                .always(function () {
                    that.endOperation();
                });
        }

        NacistDatovouSchrankuPoKontrole() {
            let that = this;
            Gin.Globals.ShowWaitLoadData(that);
            that.call<Gordic.Gin.WebClient.GRetValDlg>("NacistDatovouSchranku")
                .done(function (r) {
                    if (r.StavBool) {
                        that.endOperation();
                        if (r.Message) Wfl.AC.WflBaseAC.ShowFlashSuccess(that, r.Message);
                        that.LoadData(that.model)
                    }
                    else {
                        that.endOperation();
                        if (r.Message) that.dialogs.alert(r.Message);
                        if (r.ErrorMessage) that.dialogs.alert(r.ErrorMessage);
                    }
                })
                .always(function () {
                    that.endOperation();
                });
        }

        KontrolaStavuSchranky(_typ: Gin.Interface.TypMailboxu): JQuery.Promise<boolean> {
            let promis = $.Deferred<boolean>();
            let that = this;
            Gin.Globals.ShowWaitInfo(that, "jres:23900234"); //RC 23900234 : Probíhá kontrola
            this.call<Wfl.Interface.GDictionaryDto[] > ("IsLockedMailbox", { Typ: _typ })
                .done(function (zamceneMailboxy) {
                    that.endOperation();
                    if (zamceneMailboxy.length > 0)
                    {
                        var promises: JQuery.Promise<any>[] = [];
                        for (var i = 0; i < zamceneMailboxy.length; i++) {
                            promises.push(that.OdemknoutZamceneMailboxy(zamceneMailboxy[i]));
                        }

                        $.when.apply(null, promises).done(
                            function (odemceno) {
                                promis.resolve(odemceno);
                            });
                    }
                    else {
                        promis.resolve(true);
                    }
                })
                .fail(function (reason) { that.endOperation(); that.dialogs.warning(reason.statusText); });
            return promis.promise();
        }

        OdemknoutZamceneMailboxy(mailbox: Wfl.Interface.GDictionaryDto): JQuery.Promise<boolean> {
            let promis = $.Deferred<boolean>();
            let that = this;
            that.dialogs.confirm("jres:23900231", mailbox.Value).on("close", function (ev, retVal)//RC 23900232 : Odemknout zamčenou schránku?
            {
                if (retVal && retVal === "yes")
                {
                    Gin.Globals.ShowWaitInfo(that, "jres:23900233"); //RC 23900233 : Odemykám schránku
                    that.call("OdemkniMailbox", { Mailbox: mailbox })
                        .done(function () { promis.resolve(true); })
                        .always(function () { that.endOperation(); });
                } else promis.resolve(false);
            });

            return promis.promise();
        }

        CreateActionNacistMailovouSchranku(): GAction {
            let that = this;
            var l_tooltip = "jres:23900036";
            if (this.MailboxInfoDto.NacistMailSchrankuVisible) l_tooltip = this.MailboxInfoDto.LastDownLoadEmaily

            var action = new GAction({
                name: Gordic.Pod.Globals.ActionsName.nacistMailSchranku,
                icon: Gordic.Gin.Icons.EntityEnum.email,
                caption: "jres:23900028", //RC 23900028 : Načíst maily
                tooltip: l_tooltip, //RC 23900036 : Načíst mailovou schránku                
                visible: this.MailboxInfoDto.NacistMailSchrankuVisible,
                groupName: Gordic.Gin.Globals.Enums.ActionsGroupName.FavoriteAlwaysEnabled,
                run: function (ev, ctx)
                {
                    that.NacistMailovouSchranku();
                }
            });
            return action;
        }

        CreateActionElPodani(): GAction {
            let that = this;
            var action = new GAction({
                name: Gordic.Pod.Globals.ActionsName.elPodani,
                icon: Gordic.Pod.Icons.ActionEnum.elPodani,
                caption: "jres:23900050", //RC 23900050 : Podání do SSL
                tooltip: "jres:23900050",
                groupName: Gordic.Gin.Globals.Enums.ActionsGroupName.Favorite,
                run: function (ev, ctx) {
                    var rowData = Wfl.ListAC.WflListBaseAC.GetActiveRow(that);
                    if (rowData) {
                        var l_po: string[] = [];
                        l_po.push(rowData.ixb);
                        Gordic.Pod.Dialogs.EvidenceElPodaniDlg(that, { IxbArray: l_po, PouzePrehled: false }, Global.Enums.ModOtevreni.navigate)
                            .done(function (retVal: any) {      
                                that.ReloadData();
                                if (retVal && retVal.zobrazitDetailPozavreniPruvodce && retVal.pidDokumentu) { 
                                    var opt = {
                                        DetailDto:
                                        {
                                            ixp: retVal.pidDokumentu
                                        }
                                    };
                                    Gordic.Wfl.Dialogs.DetailDokumentuSpisu(that, opt);
                                }
                            }
                            );
                    }
                }
            });
            return action;
        }

        CreateActionHromadneElPodani(): GAction {
            let that = this;
            var action = new GAction({
                name: Gordic.Pod.Globals.ActionsName.elPodaniHromadne,
                icon: Gordic.Pod.Icons.ActionEnum.elPodani,
                caption: "jres:23900097", //RC 23900097 : Hromadné podání do SSL
                tooltip: "jres:23900097",
                groupName: Gordic.Gin.Globals.Enums.ActionsGroupName.Favorite,
                run: function (ev, ctx)
                {
                    var l_list = that.mainGrid.ggrid("getSelection").map((o) => { return { zpusob_dor: o.zpusob_dor, mail_from: o.mail_from }; }) as Wfl.Interface.GElPodaniDto[];
                    var l_odesilatel = "";
                    for (var i = 0; i < l_list.length; i++) {
                        if (l_list[i].zpusob_dor != Wfl.Interface.TypPrijmuPodani.EMail)
                        {
                            Wfl.AC.WflBaseAC.ShowFlashWarning(that, "jres:23900241"); //RC 23900241 : Hromadné podání lze realizovat pouze z e-mailových zpráv.
                            return;
                        }

                        if (l_odesilatel == "") l_odesilatel = l_list[i].mail_from;
                        else
                        {
                            if (l_odesilatel != l_list[i].mail_from)
                            {
                                Wfl.AC.WflBaseAC.ShowFlashWarning(that, "jres:23900242"); //RC 23900242 : Podání musí být od stejného subjektu.
                                return;
                            }
                        }
                    }

                    var l_asSelected = Wfl.ListAC.WflListBaseAC.GetSelectedIDs(that);
                    if (l_asSelected.length > 0) {
                        Gordic.Pod.Dialogs.EvidenceElPodaniDlg(that, { IxbArray: l_asSelected, PouzePrehled: false }, Global.Enums.ModOtevreni.navigate)
                            .done(function (retVal: any) {
                                if (retVal && retVal.zobrazitDetailPozavreniPruvodce && retVal.pidDokumentu) { 
                                    that.ReloadData();
                                    var opt = {
                                        DetailDto:
                                        {
                                            ixp: retVal.pidDokumentu
                                        }
                                    };
                                    Gordic.Wfl.Dialogs.DetailDokumentuSpisu(that, opt);
                                }
                        }
                        );
                    }
                    else Wfl.ListAC.WflListBaseAC.ShowInfoNeniVybranZadnyRadek(that);
                }
            });
            return action;
        }

        CreateActionNacistDorucenkyDZ(): GAction {
            let that = this;
            var l_tooltip = "jres:23900073";
            if (this.MailboxInfoDto.NacistDatovouSchrankuVisible) l_tooltip = this.MailboxInfoDto.LastDownLoadDorucenkyDatovychZprav
            var action = new GAction({
                name: Gordic.Pod.Globals.ActionsName.nacistDorucenkyDZ,
                icon: Gordic.Gin.Icons.ActionEnum.dorucit,
                caption: "jres:23900073", //RC 23900073 : Načíst doručenky DZ
                tooltip: l_tooltip, //RC 23900073 : Načíst doručenky DZ
                visible: this.MailboxInfoDto.NacistDatovouSchrankuVisible,
                groupName: Gordic.Gin.Globals.Enums.ActionsGroupName.FavoriteAlwaysEnabled,
                run: function (ev, ctx)
                {
                    Gordic.Wfl.Dialogs.ServisniSeznamDatovychZpravDlg(that, { ZobrazDorucenky: true }, Gordic.Global.Enums.ModOtevreni.showModalWindow);
                }
            });
            return action;
        }

        CreateActionPrevzit(): GAction {
            let that = this;
            var action = new GAction({
                name: Gordic.Gin.Globals.Enums.ActionsName.Prevzit,
                icon: Gordic.Gin.Icons.ActionEnum.prevzit,
                caption: "jres:23900237", //RC 23900237 : Převzít
                tooltip: "jres:23900237",
                run: function (ev, ctx)
                {
                    var l_asSelected = Wfl.ListAC.WflListBaseAC.GetSelectedIxsDatZmena(that);
                    if (l_asSelected.length > 0) {
                        that.call("Rozdelit", { Selected: l_asSelected, IxsFun: that.SessionInfo.IxsFun })
                            .done(function (r) {
                                Wfl.ListAC.WflListBaseAC.ResolveResultInfo(that, r)
                            })
                            .always(function () {
                                that.endOperation();
                            });
                    } else Wfl.ListAC.WflListBaseAC.ShowInfoNeniVybranZadnyRadek(that);
                }
            });
            return action;
        }

        CreateActionRozdelit(): GAction
        {
            let that = this;
            var action = new GAction({
                name: "actRozdelit",
                icon: "gi-predat",
                caption: "jres:23900079", //RC 23900079 : Rozdělit
                tooltip: "jres:23900079", 
                run: function (ev, ctx) {
                    Gordic.Wfl.Dialogs.GReferentEditUniversalDlg(that, { Label: "jres:23900080", IxsFunDefault: "" }, Gordic.Global.Enums.ModOtevreni.showModalWindow) //RC 23900080 : Přerozdělení el. podání
                        .done(function (retVal) {
                            if (retVal != null) {
                                if (retVal.ixs_fun && retVal.ixs_fun != "") {
                                    var l_asSelected = Wfl.ListAC.WflListBaseAC.GetSelectedIxsDatZmena(that);
                                    if (l_asSelected.length > 0) {
                                        that.call("Rozdelit", { Selected: l_asSelected, IxsFun: retVal.ixs_fun })
                                            .done(function (r) {
                                                Wfl.ListAC.WflListBaseAC.ResolveResultInfo(that, r)
                                            })
                                            .always(function () {
                                                that.endOperation();
                                            });
                                    } else Wfl.ListAC.WflListBaseAC.ShowInfoNeniVybranZadnyRadek(that);
                                }
                            }
                        });
                }
            });
            return action;
        }
    }
}
